import { useEffect } from "react";

// Mobilde tablolar kart görünümüne geçer (styles/mobile.css). Kartta her hücrenin
// başlığını göstermek için <td>'lere kolon başlığından data-label yazılır.
// Sayfalar tek tek değiştirilmesin diye, içerik değiştikçe burada otomatik yapılır.
const SKIP = ".calendar, .range-calendar-table, .no-stack";

const labelTable = (table) => {
  if (table.matches(SKIP)) return;
  const headRow = table.tHead?.rows?.[table.tHead.rows.length - 1];
  if (!headRow) return;
  const labels = Array.from(headRow.cells).map((th) => th.textContent.trim());
  table.classList.add("stack-mobile");
  Array.from(table.tBodies).forEach((body) => {
    Array.from(body.rows).forEach((row) => {
      let col = 0;
      Array.from(row.cells).forEach((cell) => {
        const span = cell.colSpan || 1;
        if (span > 1) {
          cell.classList.add("stack-full"); // "Kayıt yok" gibi tüm satırı kaplayan hücre
        } else if (!cell.hasAttribute("data-label") && labels[col]) {
          cell.setAttribute("data-label", labels[col]);
        }
        col += span;
      });
    });
  });
};

const useStackedTables = (rootRef) => {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    let frame = null;
    const run = () => {
      frame = null;
      root.querySelectorAll("table").forEach(labelTable);
    };
    const schedule = () => {
      if (frame == null) frame = requestAnimationFrame(run);
    };
    run();
    const observer = new MutationObserver(schedule);
    observer.observe(root, { childList: true, subtree: true });
    return () => {
      observer.disconnect();
      if (frame != null) cancelAnimationFrame(frame);
    };
  }, [rootRef]);
};

export default useStackedTables;
